import ReadMore from './container';

export default ReadMore;
